import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const UGL_LOGO = "/ugl-logo.png";

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen section-dark text-white" role="main" aria-label="Cookie Policy">
      <header className="glass-header bg-[#001830]/90 border-b border-white/10 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 sm:px-12 flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-3">
            <img src={UGL_LOGO} alt="UGL" className="w-8 h-8 object-contain" />
            <span className="font-semibold text-white text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>UGL Lariano</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm" className="text-white/60 hover:text-white hover:bg-white/5">
              <ArrowLeft className="w-4 h-4 mr-1" /> Torna alla Home
            </Button>
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 sm:px-12 py-16">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-px w-8 bg-[#C9A84C]/60" />
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#C9A84C]">Informativa Legale</p>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Cookie Policy</h1>
        <div className="flex items-center gap-3 mb-10">
          <div className="h-px w-12 bg-[#C9A84C]/40" />
          <div className="w-2 h-2 rotate-45 border border-[#C9A84C]/40" />
          <div className="h-px w-20 bg-[#C9A84C]/30" />
        </div>

        <div className="space-y-8 text-white/60 leading-relaxed" style={{ fontFamily: "'Georgia', serif" }}>
          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Cosa sono i Cookie</h2>
            <p>I cookie sono piccoli file di testo che i siti visitati dall'utente inviano al suo terminale (computer, tablet, smartphone), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. I cookie sono utilizzati per diverse finalita, hanno diverse caratteristiche e possono essere utilizzati sia dal titolare del sito che si sta visitando, sia da terze parti.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Tipologie di Cookie Utilizzati</h2>

            <div className="glass-card rounded-lg border border-white/10 p-5 mb-4">
              <h3 className="text-sm font-semibold text-[#C9A84C] mb-2">Cookie Tecnici (Necessari)</h3>
              <p className="text-sm">Questi cookie sono essenziali per il corretto funzionamento del sito web. Includono cookie di sessione per l'autenticazione degli utenti registrati e cookie per la memorizzazione delle preferenze di navigazione. Non richiedono il consenso dell'utente.</p>
            </div>

            <div className="glass-card rounded-lg border border-white/10 p-5 mb-4">
              <h3 className="text-sm font-semibold text-[#00A0D1] mb-2">Cookie Funzionali</h3>
              <p className="text-sm">Permettono al sito di ricordare le scelte dell'utente (come il consenso ai cookie) e di fornire funzionalita personalizzate. Le informazioni raccolte da questi cookie possono essere anonimizzate.</p>
            </div>

            <div className="glass-card rounded-lg border border-white/10 p-5">
              <h3 className="text-sm font-semibold text-white/70 mb-2">Cookie Analitici</h3>
              <p className="text-sm">Vengono utilizzati per raccogliere informazioni sull'uso del sito da parte degli utenti in forma aggregata e anonima. Ci aiutano a capire come i visitatori interagiscono con il sito, fornendo informazioni sulle aree visitate e il tempo trascorso.</p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Cookie Utilizzati nel Dettaglio</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-white/10">
                    <th className="text-left py-3 pr-4 text-[#C9A84C] font-semibold text-xs uppercase tracking-wider">Nome</th>
                    <th className="text-left py-3 pr-4 text-[#C9A84C] font-semibold text-xs uppercase tracking-wider">Tipo</th>
                    <th className="text-left py-3 pr-4 text-[#C9A84C] font-semibold text-xs uppercase tracking-wider">Durata</th>
                    <th className="text-left py-3 text-[#C9A84C] font-semibold text-xs uppercase tracking-wider">Finalita</th>
                  </tr>
                </thead>
                <tbody className="text-white/50">
                  <tr className="border-b border-white/5">
                    <td className="py-3 pr-4 font-mono text-xs">access_token</td>
                    <td className="py-3 pr-4">Tecnico</td>
                    <td className="py-3 pr-4">24 ore</td>
                    <td className="py-3">Autenticazione utente</td>
                  </tr>
                  <tr className="border-b border-white/5">
                    <td className="py-3 pr-4 font-mono text-xs">refresh_token</td>
                    <td className="py-3 pr-4">Tecnico</td>
                    <td className="py-3 pr-4">7 giorni</td>
                    <td className="py-3">Rinnovo sessione</td>
                  </tr>
                  <tr className="border-b border-white/5">
                    <td className="py-3 pr-4 font-mono text-xs">ugl_cookies</td>
                    <td className="py-3 pr-4">Funzionale</td>
                    <td className="py-3 pr-4">Persistente</td>
                    <td className="py-3">Consenso cookie</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Gestione dei Cookie</h2>
            <p>L'utente puo gestire le proprie preferenze relative ai cookie direttamente all'interno del proprio browser ed impedire che terze parti possano installarne. Tramite le preferenze del browser e inoltre possibile eliminare i cookie installati in passato. E importante notare che disabilitando tutti i cookie, il funzionamento del sito potrebbe essere compromesso.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Come Disabilitare i Cookie</h2>
            <p>Di seguito i link alle guide per la gestione dei cookie nei principali browser:</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#00A0D1] hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-[#00A0D1] hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#00A0D1] hover:underline">Apple Safari</a></li>
              <li><a href="https://support.microsoft.com/it-it/windows/eliminare-e-gestire-i-cookie" target="_blank" rel="noopener noreferrer" className="text-[#00A0D1] hover:underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Riferimenti Normativi</h2>
            <p>La presente cookie policy e redatta ai sensi del Regolamento (UE) 2016/679 (GDPR), della Direttiva 2002/58/CE (Direttiva ePrivacy) e del provvedimento del Garante per la protezione dei dati personali dell'8 maggio 2014 e delle Linee guida del 10 giugno 2021.</p>
          </section>

          <div className="pt-6 border-t border-white/10">
            <p className="text-xs text-white/30">Ultimo aggiornamento: Marzo 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
}
